import { createIcon } from "@chakra-ui/icons";

// Created from star.svg

export const StarIcon = createIcon({
  displayName: "Star",
  viewBox: "0 0 24 24",
  path: (
    <path
      fill="none"
      d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
});
